import {
  FaEnvelope,
  FaGithub,
  FaGooglePlay,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import { SiUdemy } from "react-icons/si";
import { socials } from "../../data/site";

const icons = {
  LinkedIn: FaLinkedin,
  GitHub: FaGithub,
  Instagram: FaInstagram,
  YouTube: FaYoutube,
  Udemy: SiUdemy,
  Email: FaEnvelope,
  "Play Store": FaGooglePlay,
};

function toneClass(label) {
  return `tone-${label.toLowerCase().replace(/\s+/g, "-")}`;
}

export default function SocialLinks({ labeled = false }) {
  return (
    <ul className={labeled ? "flex flex-col" : "flex flex-wrap items-center gap-x-1"}>
      {socials.map((item) => {
        const Icon = icons[item.label];
        const external = item.href.startsWith("http");

        return (
          <li key={item.label}>
            <a
              href={item.href}
              className={`social-link ${toneClass(item.label)} ${labeled ? "social-link-labeled" : ""}`}
              {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              <Icon aria-hidden="true" size={18} />
              {labeled ? <span>{item.label}</span> : <span className="sr-only">{item.label}</span>}
              {external ? <span className="sr-only"> (opens in a new tab)</span> : null}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
